module.exports = __webpack_public_path__ + "static/zendesk-70ed7130fa809bebab5730fa40f97480.png";